import { render, staticRenderFns } from "./PenaltyPopup.vue?vue&type=template&id=56a6ec56&scoped=true"
import script from "./PenaltyPopup.vue?vue&type=script&lang=js"
export * from "./PenaltyPopup.vue?vue&type=script&lang=js"
import style0 from "./PenaltyPopup.vue?vue&type=style&index=0&id=56a6ec56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a6ec56",
  null
  
)

export default component.exports